<h2 class="text-xl font-semibold mb-2 text-gray-700">{{title}}</h2>
<h2 class="text-sm font-semibold mb-2 text-gray-700">{{subtitle}}</h2>
<p class="text-gray-500 text-md mb-2">{{description}}</p>
